<template>
  <v-flex xs6 class="mr-1">
    <v-card class="mb-2">
      <v-card-title class="mb-2">
        <v-avatar class="secondary">
          <v-icon dark>fas fa-pound-sign</v-icon>
        </v-avatar>
        <div class="ml-3">
          <h4 class="headline">Fee Tiers</h4>
          <span class="body-2"
            >Fees can be manually adjusted when setting funding released on an enquiry<br />
            Fee Tiers require a minimum of 2 entries<br />
            Use zero for a percentage to applied beyond the upper limit (ie Over £10,000)</span
          >
        </div>
      </v-card-title>
      <v-card flat>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 sm3 class="header">Amount</v-flex>
              <v-flex xs6 sm3 class="header">Percentage Fee (Prime)</v-flex>
              <v-flex xs6 sm3 class="header">Percentage Fee (Sub Prime)</v-flex>
              <v-flex xs6 sm3 class="header"></v-flex>
            </v-layout>
            <v-layout v-for="feeTier in nonZeroFeeTiers" :key="feeTier.id" wrap>
              <v-flex xs6 sm3>Up to {{ feeTier.amount | currency('£', ',', 0) }}</v-flex>
              <v-flex xs6 sm3>{{ feeTier.prime_fee }}</v-flex>
              <v-flex xs6 sm3>{{ feeTier.sub_prime_fee }}</v-flex>
              <v-flex xs6 sm3 class="text-md-right">
                <v-btn color="accent" @click.native="deleteTier(feeTier)">Remove</v-btn>
              </v-flex>
            </v-layout>
            <v-layout v-for="feeTier in zeroFeeTiers" :key="feeTier.id" wrap>
              <v-flex xs6 sm3>
                Over
                {{ SelectedFunder.fee_tiers[SelectedFunder.fee_tiers.length - 1].amount | currency('£', ',', 0) }}
              </v-flex>
              <v-flex xs6 sm3>{{ feeTier.prime_fee }}</v-flex>
              <v-flex xs6 sm3>{{ feeTier.sub_prime_fee }}</v-flex>
              <v-flex xs6 sm3 class="text-md-right">
                <v-btn color="accent" @click="deleteTier(feeTier)">Remove</v-btn>
              </v-flex>
            </v-layout>
            <v-form lazy-validation>
              <v-layout wrap>
                <v-flex xs6 sm3>
                  <v-text-field label="Upper limit" v-model="feeTier.amount" required></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field label="Percentage (Prime)" v-model="feeTier.prime_fee" required></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field label="Percentage (Sub Prime)" v-model="feeTier.sub_prime_fee" required></v-text-field>
                </v-flex>
                <v-flex xs6 sm3 class="text-md-right"
                  ><v-btn color="accent" @click.native="saveFeeTier">Add</v-btn></v-flex
                >
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'feeTiers',
  data: () => ({
    feeTier: {
      parent_id: null,
      amount: null,
      prime_fee: null,
      sub_prime_fee: null
    }
  }),
  computed: {
    ...mapGetters(['SelectedFunder']),
    nonZeroFeeTiers() {
      return this.SelectedFunder.fee_tiers.filter(tier => Number(tier.amount) > 0);
    },
    zeroFeeTiers() {
      return this.SelectedFunder.fee_tiers.filter(tier => Number(tier.amount) === 0);
    }
  },
  methods: {
    ...mapActions(['deleteFeeTier', 'addFeeTier']),
    deleteTier(feeTier) {
      feeTier.parent_id = this.SelectedFunder.id;
      this.deleteFeeTier(feeTier);
    },
    saveFeeTier() {
      this.feeTier.parent_id = this.SelectedFunder.id;
      this.addFeeTier(this.feeTier);
      this.feeTier = {
        parent_id: null,
        amount: null,
        prime_fee: null,
        sub_prime_fee: null
      };
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .header {
    font-weight: 700;
    font-size: 0.9rem;
    color: rgba(0, 0, 0, 0.54);
    border-bottom: 1px solid #ddd;
  }
}
</style>
